<template>
  <div class="operation" style="padding:20px 0;">
    <el-tabs
      v-model="activeName"
      type="card"
      style="margin-bottom:0px !important;"
      @tab-click="handleClick(activeName)"
    >
      <el-tab-pane
        :label="item.title"
        :name="item.name"
        class="tab-text"
        v-for="item in productListTabs"
        :key="item.name"
      >
        <div>
          <div class="box-table" style="padding-top:0 !important;" v-if="activeName==='产品清单'">
            <p style="text-align:right;margin:0 0 10px 0;">
              <el-button
                @click="onInitiateLossReporting"
                :disabled="!isLack"
                type="primary"
                plain
              >发起报缺</el-button>
            </p>
            <el-table
              border
              ref="tableRef"
              :data="productList"
              max-height="378"
              tooltip-effect="dark"
              :header-cell-style="tableHeader"
              v-loading="loadingProTable"
              element-loading-text="拼命加载中请稍后..."
              element-loading-spinner="el-icon-loading"
            >
              <el-table-column show-overflow-tooltip min-width="150px" prop="brandName" label="品牌"></el-table-column>
              <el-table-column show-overflow-tooltip min-width="150px" prop="seriesName" label="系列"></el-table-column>
              <el-table-column show-overflow-tooltip min-width="150px" prop="proName" label="产品名称"></el-table-column>
              <el-table-column show-overflow-tooltip min-width="150px" prop="proModel" label="型号">
                <template scope="scope">
                  <span
                    class="approval"
                    @click="productSkip(scope.row.proId)"
                  >{{scope.row.proModel}}</span>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                min-width="150px"
                prop="proOrderNum"
                label="订货号"
              ></el-table-column>
              <el-table-column show-overflow-tooltip min-width="100px" prop="proUnit" label="单位"></el-table-column>
              <el-table-column show-overflow-tooltip min-width="100px" prop="pccCount" label="数量"></el-table-column>
              <el-table-column show-overflow-tooltip min-width="100px" prop="proExtype" label="类型"></el-table-column>
              <el-table-column
                show-overflow-tooltip
                min-width="100px"
                prop="pcbExtimeValue"
                label="货期"
              >
                <template slot-scope="scope">
                  <div class="line-limit-length">{{ scope.row.pcbExtimeValue ? scope.row.pcbExtimeValue +'天':'--'}}</div>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip min-width="130px" prop="cbRemind" label="提醒">
                <template scope="scope">
                  <span>{{scope.row.cbRemind | dateFilter}}</span>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                min-width="100px"
                prop="purchasePrice"
                label="采购单价"
              >
                <template scope="scope">
                  <div class="line-limit-length">{{scope.row.purchasePrice | priceFilterNum}}</div>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                min-width="100px"
                prop="discountPrice"
                label="抵扣金额"
              >
                <template scope="scope">
                  <div class="line-limit-length">{{scope.row.discountPrice | priceFilterNum}}</div>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                min-width="100px"
                prop="amountPaid"
                label="实付单价"
              >
                <template scope="scope">
                  <div class="line-limit-length">{{scope.row.amountPaid | priceFilterNum}}</div>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip min-width="100px" prop="proPrice" label="面价">
                <template scope="scope">
                  <div class="line-limit-length">{{scope.row.proPrice | priceFilterNum}}</div>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                min-width="100px"
                prop="deliverState"
                label="发货状态"
              ></el-table-column>
              <el-table-column
                show-overflow-tooltip
                min-width="100px"
                prop="invoiceState"
                label="收票状态"
              ></el-table-column>
            </el-table>
          </div>
          <div class="box-table" v-if="activeName==='报缺产品'">
            <el-table
              border
              ref="tableRef"
              :data="missingProductsList"
              tooltip-effect="dark"
              max-height="378"
              :header-cell-style="tableHeader"
              v-loading="loadingProTable"
              element-loading-text="拼命加载中请稍后..."
              element-loading-spinner="el-icon-loading"
            >
              <el-table-column show-overflow-tooltip label="关联入库单号" min-width="180px">
                <template scope="scope">
                  <span>{{scope.row.instockNumber}}</span>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip min-width="100px" prop="brandName" label="品牌"></el-table-column>
              <el-table-column show-overflow-tooltip min-width="150px" prop="seriesName" label="系列"></el-table-column>
              <el-table-column show-overflow-tooltip min-width="120px" prop="proName" label="产品名称"></el-table-column>
              <el-table-column show-overflow-tooltip min-width="100px" prop="proModel" label="型号">
                <template scope="scope">
                  <span class="approval">{{scope.row.proModel}}</span>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="proOrderNum" label="订货号"></el-table-column>
              <el-table-column show-overflow-tooltip min-width="100px" prop="proUnit" label="单位"></el-table-column>
              <el-table-column show-overflow-tooltip prop="pccCount" label="数量"></el-table-column>
              <el-table-column show-overflow-tooltip prop="proExtype" label="类型"></el-table-column>
              <el-table-column show-overflow-tooltip prop="pcbExtimeValue" label="货期">
                <template scope="scope">
                  <span>{{scope.row.pcbExtimeValue || '--'}}</span>
                  <span v-if="scope.row.pcbExtimeValue">天</span>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="purchasePrice" label="采购单价">
                <template scope="scope">
                  <span>{{scope.row.purchasePrice |priceFilterNum}}</span>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="discountPrice" label="抵扣金额">
                <template scope="scope">
                  <span>{{scope.row.discountPrice |priceFilterNum}}</span>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="amountPaid" label="实付单价">
                <template scope="scope">
                  <span>{{scope.row.amountPaid |priceFilterNum}}</span>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="proPrice" label="面价">
                <template scope="scope">
                  <span>{{scope.row.proPrice |priceFilterNum}}</span>
                </template>
              </el-table-column>
              <!--              <el-table-column show-overflow-tooltip prop="lackState" label="报缺状态">-->
              <!--                <template scope="scope">-->
              <!--                  <span>{{ status[scope.row.lackState-1]}}</span>-->
              <!--                </template>-->
              <!--              </el-table-column>-->
              <el-table-column show-overflow-tooltip prop="createUser" label="提交人"></el-table-column>
              <el-table-column show-overflow-tooltip prop="createDate" width="130" label="提交时间">
                <template scope="scope">
                  <span class="line-limit-length">{{scope.row.createDate | dateFilter}}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <!--        <div class="pagination">-->
        <!--          <pagination-->
        <!--            :total="total"-->
        <!--            @handleCurrentChange="handleCurrentChange"-->
        <!--            @handleSizeChange="handleSizeChange"-->
        <!--          ></pagination>-->
        <!--        </div>-->
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { purchaseQueryByPcbId, queryByLack } from '@/api/purchase/purchasePlanList' // 根据采购合同id查询正常产品清单（分页)
import { formatDate } from '@/util/tool'
import { productListTabs } from '../../util/data'
export default {
  components: {},
  data() {
    return {
      status: ['待发起', '审批中', '驳回', '通过'],
      isLack: true,
      activeName: '产品清单',
      productListTabs: productListTabs,
      productList: [], // 产品清单列表
      loadingProTable: false,
      missingProductsList: [], // 报缺产品列表
      pageSize: 30, // 页数
      currentPage: 1, // 页码
      total: 0 // 列表总数
    }
  },
  methods: {
    productSkip(id) {
      this.$router.push({
        name: 'productDetails',
        query: { id: id }
      })
    },
    onInitial() {
      if (this.activeName === '报缺产品') {
        // this.queryPurchaseLack()
      } else {
        this.purchaseQueryByPcbId()
      }
    },
    // 正常的请求数据
    purchaseQueryByPcbId() {
      this.loadingProTable = true
      purchaseQueryByPcbId(this.$route.query.pcbId, this.currentPage, this.pageSize)
        .then(res => {
          if (res.data.code === 200) {
            this.total = res.data.obj.purchaseContractContentVoPage.total
            this.productList = res.data.obj.purchaseContractContentVoPage.records
            this.isLack = res.data.obj.isLack
          }
          this.loadingProTable = false
        })
        .catch(err => {
          this.loadingProTable = false
          console.log(err)
        })
    },

    // 报缺请求数据
    queryPurchaseLack() {
      const params = {
        criteriaVoList: [{}],
        queryPageName: ''
      }
      this.loadingProTable = true
      queryByLack(this.$route.query.pcbId, this.currentPage, this.pageSize, params)
        .then(res => {
          if (res.data.code === 200) {
            this.missingProductsList = res.data.obj.purchaseContractLackContentVoPage.records
            this.total = res.data.obj.purchaseContractLackContentVoPage.total
          }
          this.loadingProTable = false
        })
        .catch(err => {
          this.loadingProTable = false
          console.log(err)
        })
    },

    handleClick(val) {
      this.currentPage = 1
      if (val === '报缺产品') {
        this.queryPurchaseLack()
      } else {
        this.purchaseQueryByPcbId()
      }
    },
    // 发起报缺
    onInitiateLossReporting() {
      this.$router.push({
        name: 'initiateLossReporting',
        query: {
          pcbId: this.$route.query.pcbId,
          type: this.$route.query.type,
          activeName: '产品清单'
        }
      })
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 页数
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    // 页码
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    }
  },
  filters: {
    dateFilter
  }
}
function dateFilter(time) {
  if (time === null) {
    return ''
  } else {
    const date = new Date(time)
    return formatDate(date, 'yyyy-MM-dd hh:mm')
  }
}
</script>
